/*
This is only used if there is a non-application logic error
(for instance a server 500).
If the web UI is offline, it should not go here.
The idea is to prevent us from DDOSing ourselves if we have a major
server side outage.
The clients won't all try to hit us at once when we come back up.
*/

import { totalAttemptsFor, recordRetryScheduled } from './attemptCounts';

export const decaySchedule = [
    1000, // After 1 seconds
    1000 * 5, // After 5 seconds
    1000 * 15, // After 15 seconds
    1000 * 30, // After 30 seconds
    1000 * 60, // After 1 minute
    1000 * 60 * 3, // After 3 minutes
    1000 * 60 * 5, // After 5 minutes
    1000 * 60 * 10, // After 10 minutes
    1000 * 60 * 30, // After 30 minutes
    1000 * 60 * 60 // After 1 hour
];

// The number of progressive back offs a queued action gets before the schedule flattens out at
// one hour. discardOverride uses this to bound retries of a server error that never resolves.
export const MAX_DECAY_STEPS = decaySchedule.length;

// Called once redux-offline has decided to schedule a retry, which is where it increments its own
// outbox-wide counter - so this is the point at which the attempt is charged to this action.
export default (action, retries) => {
    const attempts = totalAttemptsFor(action, retries);
    recordRetryScheduled(action);
    return decaySchedule[Math.min(attempts, MAX_DECAY_STEPS - 1)];
};
